import { render, staticRenderFns } from "./VisitsStep.vue?vue&type=template&id=1320e313&scoped=true"
import script from "./VisitsStep.vue?vue&type=script&lang=ts"
export * from "./VisitsStep.vue?vue&type=script&lang=ts"
import style0 from "./VisitsStep.vue?vue&type=style&index=0&id=1320e313&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320e313",
  null
  
)

export default component.exports